import { useMemo } from 'react';

export const useMappedValue = <T, X>(
  t: T,
  mapFn: (t: T) => X,
  mutableMapFn = false
): X => {
  return useMemo(() => mapFn(t), [t, mutableMapFn ? mapFn : 'xxx']);
};
